import { useEffect, useMemo } from "react";
import { useLocSettings } from "../../hooks/SettingsHooks";
import { facetProducts } from "../../utils/ProductsUtils";
import ProductsFilter from "./ProductsFilter";
import { useCategory } from "../../hooks/ProductHooks";
import "./style.scss";

const ProductsFilters = ({
  categoryId,
  products,
  allProducts,
  activeFilters,
  setFilter
}) => {
  const category = useCategory(categoryId);
  const settings = useLocSettings();
  const filterFields = useMemo(
    () => category?.available_filters || [],
    [category]
  );
  const valueOrder = useMemo(
    () => settings.specification_value_order,
    [settings]
  );
  const hiddenSpecs = useMemo(
    () =>
      Array.isArray(settings?.hidden_specifications)
        ? settings.hidden_specifications
        : [],
    [settings.hidden_specifications]
  );

  const filterData = useMemo(() => {
    const filterData = {};
    filterFields.forEach(filterField => {
      if (!hiddenSpecs.includes(filterField)) {
        const allFacets = facetProducts(allProducts, filterField);
        const curFacets = facetProducts(products, filterField);
        const facets = {};
        Object.entries(allFacets)
          .sort(([a], [b]) =>
            valueOrder[filterField]
              ? valueOrder[filterField].indexOf(a) -
                valueOrder[filterField].indexOf(b)
              : a.localeCompare(b)
          )
          .forEach(([value, count]) => {
            facets[value] = { total: count };
          });
        Object.entries(curFacets).forEach(([value, count]) => {
          facets[value].filteredCount = count;
        });
        filterData[filterField] = facets;
      }
    });
    // add active filter values that are missing from facets with count 0 to be able to unselect them
    Object.entries(activeFilters).forEach(([field, values]) => {
      if (filterData[field]) {
        values.forEach(value => {
          if (!filterData[field][value]) {
            filterData[field][value] = { total: 0 };
          }
        });
      }
    });
    return filterData;
  }, [
    allProducts,
    products,
    filterFields,
    valueOrder,
    hiddenSpecs,
    activeFilters
  ]);

  useEffect(() => {
    // remove activeFilters fields that are not present in filterData
    Object.entries(activeFilters).forEach(([field, values]) => {
      if (!filterData[field]) {
        values.forEach(value => {
          console.log(`Unsetting active filter: ${field}.${value}`);
          setFilter(field, value, false);
        });
      }
    });
  }, [activeFilters, filterData, setFilter]);

  //console.debug("settings.specifications", settings.specifications);

  return (
    <div className={"filters"} aria-hidden="true">
      {Object.entries(filterData).map(([filterField, data]) => (
        <ProductsFilter
          filterField={filterField}
          data={data}
          activeFilters={activeFilters}
          setFilter={setFilter}
          key={filterField}
        />
      ))}
    </div>
  );
};

export default ProductsFilters;
